export enum VariantHeart {
  White = "white",
  Grey = "grey",
  Red = "red",
  Filled = "filled",
}
